export enum RequestType {
  TryItNow = 'TRY_IT_NOW',
  Question = 'QUESTION',
  NewRequest = 'NEW_REQUEST',
}
